import { Component, OnInit, Input } from '@angular/core';
import { MdDialogRef } from '@angular/material';


@Component({
  selector: 'ota-dialog-alert',
  templateUrl: './dialog-alert.component.html',
  styleUrls: ['./dialog-alert.component.scss']
})
export class DialogAlertComponent implements OnInit {
  @Input('alertHeader') alertHeader: string;
  @Input('alertText') alertText: string;
  @Input('imageSrc') imageSrc: string = '/assets/images/icons/icon-failed.png';
  @Input('imageSrcSet') imageSrcSet: string;
  @Input('mice') isMice: boolean = false;
  @Input() confirmText: string;
  @Input('autoClose')
  set autoClose(second: number) {
    this.countdown = second;
    const interval = setInterval(() => {
      if (this.countdown <= 0){
        clearInterval(interval);
        this.dialogRef.close()
      }
      this.countdown -= 1;
    }, 1000);
  }

  public countdown;

  constructor(
    public dialogRef: MdDialogRef<DialogAlertComponent>,
  ) {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-alert/dialog-alert.component.ts